import React from 'react';
import PropTypes from 'prop-types';

import DataTable from 'react-data-table-component';

import columns from './columns';

export default function Table({ reportContents, onDelete }) {
  return (
    <div className="datatable-style">

      {reportContents && (
      <DataTable
        title=""
        columns={columns(onDelete)}
        data={reportContents}
        noDataComponent={<div className="mt20">No matching records found</div>}
        persistTableHead
        pagination
        paginationComponentOptions={{
          selectAllRowsItem: true,
          selectAllRowsItemText: 'All',
        }}
      />
      )}

    </div>
  );
}

Table.propTypes = {
  reportContents: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDelete: PropTypes.func.isRequired,
};
